var _rect, _rect2, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBri(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 50,
    viewBox: "0 0 70 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2694_170)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2694_170)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "#00529C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2694_170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 70,
    height: 50
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    rx: 6.63158,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2694_170)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72853e-06 43.7544C1.72853e-06 43.7544 -0.735189 45.5 11.5 45.5C39 45.5 70.0018 35.5 70.0018 35.5V52.0089H-0.501709L1.72853e-06 43.7544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.000111103 44C-0.000111103 44 -13.3087 46.5469 -0.000111103 47C29.4999 48.0044 70.0017 43 70.0017 43V54.0089H-0.501822L-0.000111103 44Z",
    fill: "url(#paint0_linear_2694_170)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7512 21.6909H24.0875C25.4385 21.6909 26.4457 22.2887 26.4457 23.5471C26.4457 24.4697 25.9788 24.9836 25.1678 25.2558V25.2766C26.1345 25.4763 26.6333 26.0007 26.6333 26.8914C26.6333 28.6429 25.1051 29.0096 23.8063 29.0096H20.7512V21.6909ZM22.6837 24.585H23.2246C23.8585 24.585 24.5136 24.4276 24.5136 23.8085C24.5136 23.1383 23.8898 23.0747 23.2448 23.0747H22.6837V24.585ZM22.6837 27.6258H23.2562C23.9623 27.6258 24.6999 27.5208 24.6999 26.7762C24.6999 25.98 23.9417 25.9059 23.2765 25.9059H22.6837V27.6258Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.1704 21.6909H31.54L34.3357 29.0096H32.2154L31.6754 27.4477H28.9525L28.3806 29.0096H26.4165L29.1704 21.6909ZM30.3557 23.2011H30.3339L29.3991 26.0639H31.2177L30.3557 23.2011Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6047 21.6909H37.0677L39.5205 26.6613H39.5407L39.51 21.6909H41.2773V29.0096H38.8764L36.3398 24.0083H36.3199L36.3819 29.0096H34.6047V21.6909Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.9333 21.6909H43.8661V24.6801H43.887L46.0687 21.6909H48.3975L45.7157 25.0985L48.6053 29.0096H46.1414L43.887 25.686H43.8661V29.0096H41.9333V21.6909Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.002 21.6909H54.3382C55.689 21.6909 56.6974 22.2887 56.6974 23.5471C56.6974 24.4697 56.2305 24.9836 55.4195 25.2558V25.2766C56.3858 25.4763 56.8847 26.0007 56.8847 26.8914C56.8847 28.6429 55.3568 29.0096 54.0583 29.0096H51.002V21.6909ZM52.9353 24.585H53.4753C54.1095 24.585 54.7637 24.4276 54.7637 23.8085C54.7637 23.1383 54.1409 23.0747 53.4968 23.0747H52.9353V24.585ZM52.9353 27.6258H53.5073C54.2133 27.6258 54.9516 27.5208 54.9516 26.7762C54.9516 25.98 54.1931 25.9059 53.5278 25.9059H52.9353V27.6258Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.313 21.6909H60.7635C62.0519 21.6909 63.1021 22.2778 63.1021 23.5369C63.1021 24.5119 62.6447 25.162 61.7096 25.3819V25.4026C62.3318 25.5708 62.3742 26.1261 62.738 27.0175L63.445 29.0096H61.429L61.0131 27.6893C60.618 26.4309 60.3684 26.1156 59.6513 26.1156H59.2457V29.0096H57.313V21.6909ZM59.2457 24.7318H59.7553C60.3788 24.7318 61.169 24.7104 61.169 23.8822C61.169 23.2011 60.4927 23.0747 59.7553 23.0747H59.2457V24.7318Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2694_170",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 18,
    width: 62,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 32.7057H65.9102V18H4V32.7057Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2694_170)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.9773 29.0096H65.9101V21.6909H63.9773V29.0096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3402 18H6.22346C4.99548 18 4 19.0293 4 20.2991V20.3234V30.4072C4 31.6647 4.97713 32.6869 6.1893 32.7057H16.3348C17.5631 32.7057 18.5589 31.6765 18.5589 30.4072L18.5637 20.2991C18.5637 19.0293 17.5685 18 16.3402 18ZM7.42613 31.5274L6.87414 31.5335C6.20606 31.5335 5.66451 30.9798 5.66451 30.2965L5.66135 30.1991V20.864L5.66483 20.3614C5.68982 19.7001 6.18771 19.1678 6.83998 19.1678H7.96199C8.97866 19.1678 9.80333 20.0598 9.80333 21.1123C9.80333 21.6326 9.60119 22.1049 9.2738 22.4483L6.41104 25.379L9.09412 28.1355C9.44018 28.4952 9.64928 28.9682 9.64928 29.4862C9.64928 30.6137 8.6538 31.5274 7.42613 31.5274ZM15.6747 31.5182L10.6723 31.516C10.6723 31.516 11.2508 30.2547 11.2508 29.474C11.2508 28.5223 10.9351 27.6718 10.4414 27.1091L8.73035 25.3494L10.4768 23.5289C10.9965 23.0359 11.3419 22.1607 11.3419 21.164C11.3419 20.3748 11.1256 19.6755 10.7773 19.1678H11.9895C13.0064 19.1678 13.8311 20.0598 13.8311 21.1123C13.8311 21.6326 13.6293 22.1049 13.3019 22.4483L10.4939 25.3484L16.326 31.3487C16.1412 31.4662 15.9081 31.5182 15.6747 31.5182ZM16.8963 29.6448L12.7167 25.3471L14.7073 23.3059C15.1129 22.7949 15.3697 22.0248 15.3697 21.164C15.3697 20.3697 15.1502 19.6535 14.7988 19.1454L15.6898 19.1722C16.3579 19.1722 16.8995 19.7269 16.8995 20.4099L16.8963 29.6448Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2694_170",
    x1: -5.91504,
    y1: 48.5044,
    x2: 70.0017,
    y2: 48.5044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF730A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188325,
    stopColor: "#F66F0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A18"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2694_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2694_170"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBri);
export default __webpack_public_path__ + "static/media/bri.771de345ac62cfb2fef56ce0dd228cfa.svg";
export { ForwardRef as ReactComponent };